export const validateSerialByModel = (productName = '', serial = '') => {
  const trimmedSerial = serial.trim().toUpperCase()

  if (productName.toLowerCase().includes('biosonic')) {
    return validateBiosonic(trimmedSerial)
  }

  if (productName.toLowerCase().includes('canalpro jeni evo')) {
    return validateCanalProJeniEvo(trimmedSerial)
  }

  if (productName.toLowerCase().includes('canalpro jeni')) {
    return validateCanalProJeni(trimmedSerial)
  }

  return true
}

const validateBiosonic = (value) => {
  const year = value.substr(0, 2)
  const month = value.substr(2, 2)
  const day = value.substr(4, 2)
  const index = value.substr(6)
  const date = new Date(`20${year}-${month}-${day}`)

  return (
    value.length === 9 &&
    date.getUTCFullYear() === parseInt(`20${year}`) &&
    date.getUTCMonth() + 1 === parseInt(month) &&
    date.getUTCDate() === parseInt(day) &&
    /^[0-9]{3}$/.test(index)
  )
}

const validateCanalProJeni = (value) => {
  return /^(2[0-9])\d{4}$/.test(value)
}

const validateCanalProJeniEvo = (value) => {
  return /^\d+$/.test(value)
}

const AJ_PREFIXES = ['AJA', 'AJB', 'AJC', 'AJX', 'AJZ']

function normalizeSerial(input) {
  return (input || '').trim().toUpperCase().replace(/\s+/g, '')
}

function isDigits(str) {
  return /^\d+$/.test(str)
}

function isValidYYMMDD(yymmdd) {
  if (yymmdd.length !== 6 || !isDigits(yymmdd)) return false
  const yy = Number(yymmdd.slice(0, 2))
  const mm = Number(yymmdd.slice(2, 4))
  const dd = Number(yymmdd.slice(4, 6))
  if (mm < 1 || mm > 12) return false
  const fullYear = 2000 + yy
  const d = new Date(Date.UTC(fullYear, mm - 1, dd))
  return d.getUTCFullYear() === fullYear && d.getUTCMonth() === mm - 1 && d.getUTCDate() === dd
}

export function validateSerialNumberSearch(input) {
  const serial = normalizeSerial(input)

  if (!serial) return false

  // if (serial.startsWith('0')) return false // Should not start with 0

  if (serial.length === 9 && isDigits(serial)) {
    return isValidYYMMDD(serial.slice(0, 6)) // 9 digits BioSonic(yymmddxxx)
  }

  if (serial.length === 5 && isDigits(serial)) return true // 5 digits CanalPro JENI EVO

  if (serial.length === 6 && isDigits(serial) && serial.startsWith('2')) {
    return true // 6 digits, starts with 2 Canal Pro Jeni
  }

  if (serial.length === 8 && AJ_PREFIXES.includes(serial.slice(0, 3)) && /^[A-Z0-9]{5}$/.test(serial.slice(3))) {
    return true // 8 chars: AJA/AJB/AJC/AJX/AJZ + 5 digits Bravo
  }

  if (serial.length === 12 && isDigits(serial.slice(0, 6)) && /^[A-LXZ]$/.test(serial[6]) && isDigits(serial.slice(7))) {
    return true // 12 chars: 6 digits + (A–L or X or Z) + 5 digits Scican SN
  }

  return false
}
